import { skipToken, useQuery } from '@tanstack/react-query';
import { fetchLinkActions } from './api';
import {
  findUsageChartAction,
  parseUsageActionMeta,
  type UsageActionUiMeta,
} from './utilityActionMeta';

export function utilityLinkActionsQueryKey(linkId: string): readonly [string, string] {
  return ['my-utility-link-actions', linkId];
}

export function useUtilityLinkActions(linkId: string | undefined, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: utilityLinkActionsQueryKey(linkId ?? ''),
    queryFn: linkId ? () => fetchLinkActions(linkId) : skipToken,
    enabled: (options?.enabled ?? true) && !!linkId,
    staleTime: 60_000,
  });
}

export function useUsageActionMeta(linkId: string | undefined, options?: { enabled?: boolean }) {
  const actionsQuery = useUtilityLinkActions(linkId, options);

  const usageAction = actionsQuery.data ? findUsageChartAction(actionsQuery.data) : undefined;
  const meta: UsageActionUiMeta | null = usageAction ? parseUsageActionMeta(usageAction) : null;

  return {
    ...actionsQuery,
    usageAction,
    meta,
    isMetaReady: !actionsQuery.isLoading && !!meta,
  };
}
